import { render, staticRenderFns } from "./UserCouponsData.vue?vue&type=template&id=1c033fb8&scoped=true&"
import script from "./UserCouponsData.vue?vue&type=script&lang=js&"
export * from "./UserCouponsData.vue?vue&type=script&lang=js&"
import style0 from "./UserCouponsData.vue?vue&type=style&index=0&id=1c033fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c033fb8",
  null
  
)

export default component.exports